<style lang="scss" scoped></style>

<template>
    <div class="min-h-screen-minus-footer pt-pagetop-auto">
        <div class="lg:pt-160 pt-80 container">
            <div class="flex justify-center">
                <spinner></spinner>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        orderId: {
            type: String,
            required: true,
        },
    },

    methods: {
        setCookie(name, value, days) {
            var expires = '';
            if (days) {
                var date = new Date();
                date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
                expires = '; expires=' + date.toUTCString();
            }
            document.cookie = name + '=' + (value || '') + expires + '; path=/';
        },
        getCookie(name) {
            var nameEQ = name + '=';
            var ca = document.cookie.split(';');
            for (var i = 0; i < ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) == ' ') c = c.substring(1, c.length);
                if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
            }
            return null;
        },
    },

    mounted() {
        const self = this;
        const sleep = time => new Promise(resolve => setTimeout(resolve, time));
        const poll = (promiseFn, time) => {
            promiseFn().then(response => {
                if (response && response.data.status === 'complete') {
                    window.location = `/bestelbevestiging?order=${self.orderId}`;
                } else if (response && (response.data.status === 'canceled' || response.data.status === 'failed')) {
                    window.location = `/checkout?status=${response.data.status}`;
                } else {
                    sleep(time).then(() => poll(promiseFn, time));
                }
            });
        };

        poll(() => axios.get(`/api/order/${self.orderId}`), 1000);
    },
};
</script>
